import { MemoryManager } from '../memory-manager';

export type CacheType = 'Unknown' | 'orthotile' | 'pointcloud' | 'scan';

// The CacheElement keeps trach of the time to keep itself
// When the timeout have been reached it calls the Cache to be cleared
export class CacheElement {
  // The ticker exist to have a small delay to not clear needed cached data
  private static readonly tickLimit: number = 10;
  ticker = 0;
  private timeoutId?: ReturnType<typeof setTimeout> = undefined;

  constructor(
    readonly key: string,
    readonly data: any,
    private timeoutCount: number,
    private clearCallback: any,
    readonly size = 0,
    readonly type: CacheType = 'Unknown',
  ) {
    MemoryManager.getInstance().allocate(this.size, this.type);
  }

  getData() {
    this.reset();
    return this.data;
  }

  getSize() {
    return this.size;
  }

  reset() {
    this.ticker = 0;
    // clear timer
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = undefined;
    }
  }

  tick() {
    this.ticker++;
    if (this.ticker >= CacheElement.tickLimit) {
      this.startTimer();
    }
  }

  startTimer() {
    // if timer already running, skip
    if (this.timeoutId) {
      return;
    }

    this.timeoutId = setTimeout(() => {
      this.clearCallback(this.key);
    }, this.timeoutCount);
  }

  refresh(newTimeout?: number) {
    if (newTimeout) {
      this.timeoutCount = newTimeout;
    }

    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.timeoutId = setTimeout(() => {
      this.clearCallback(this.key);
    }, this.timeoutCount);
  }

  /** Base function do clear the memory of this element */
  dispose() {
    throw new Error('Sub class need to implement dispose function');
  }
}
